import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

const SidebarButton = ({
   icon,
   linkExact,
   linkTo,
   name,
   showBadge,
   textFontFamily,
   textSize,
   textTransform
}) => (
   <NavLink
      to={linkTo}
      exact={linkExact}
      style={{
         display: 'inline-flex',
         alignItems: 'center',
         width: '100%',
         color: 'rgba(255,255,255,0.6)',
         padding: '5px 8px',
         borderRadius: '3px'
      }}
      activeStyle={{
         backgroundColor: 'rgba(255,255,255,0.12)',
         color: '#fff',
         fontWeight: 'medium'
      }}>
      <View
         display="flex"
         justifyContent="space-between"
         alignItems="center"
         width="100%">
         <View display="flex">
            {icon && (
               <View paddingRight="20px">
                  <Text size="2" color="rgba(255,255,255,0.2)">{icon}</Text>
               </View>
            )}
            <Text
               fontFamily={textFontFamily}
               size={textSize}
               transform={textTransform}
               weight="inherit"
               color="inherit">
               {name}
            </Text>
         </View>
         {showBadge && (
            <View
               margin="2px 10px 0px 10px"
               width="6px"
               height="6px"
               backgroundColor="orange"
               borderRadius="50%"
            />
         )}
      </View>
   </NavLink>
)

SidebarButton.propTypes = {
   icon: PropTypes.node,
   linkExact: PropTypes.bool,
   linkTo: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   showBadge: PropTypes.bool,
   textFontFamily: PropTypes.string,
   textSize: PropTypes.string,
   textTransform: PropTypes.string
}

SidebarButton.defaultProps = {
   icon: undefined,
   linkExact: false,
   showBadge: false,
   textFontFamily: undefined,
   textSize: '2.5',
   textTransform: 'none'
}

export default SidebarButton
